import { SCOPE_TABS, type TabCounts } from "./tabs.ts";

/**
 * What changes whether a touch page's chat panel is open (ADR-061's amendment of 2026-10-31, decision 9: every panel
 * starts closed and is opened on purpose): a tap on the Chat button, the input taking focus by a hardware key, the
 * close control, and a tap on the world outside the panel.
 */
export type PhoneChatEvent = "button" | "focus" | "close" | "outside";

/**
 * Whether the panel is open after an event.
 *
 * @param event What happened.
 * @returns True after the button or the input's focus; false after the close control or a tap outside.
 * @example
 * phoneOpenAfter("button");
 * // true
 */
export function phoneOpenAfter(event: PhoneChatEvent): boolean {
  return event === "button" || event === "focus";
}

/**
 * Whether the Chat button shows its unread dot: any scope holds a line the player has not seen.
 *
 * @param counts What each scope's tab has not shown.
 * @returns True when any count is above zero.
 */
export function phoneUnread(counts: TabCounts): boolean {
  return SCOPE_TABS.some((scope) => counts[scope] > 0);
}
